import Util from '../services/util/-RFC.util.js';

let _appIntegrations = [];
const observableAppIntegrations = new Rx.BehaviorSubject(_appIntegrations);

const AppIntegrationsRepository = {
    replace(data, included) {

        included.forEach((includedApp) => {

            const includedAppId = includedApp.id;
            // take the manifest from the 'data' param
            const appData = data.find(app => (String(app.id) === (`${includedAppId}-dashboard`)));
            includedApp.attributes.custom = appData.attributes.custom;

        });
        _appIntegrations = included;
        observableAppIntegrations.onNext(_appIntegrations);

    },

    /**
     * @ngdoc function
     * @name repositories.AppIntegrationsRepository#getSupportedOsTypes
     * @methodOf repositories.AppIntegrationsRepository
     * @function
     *
     * @description
     * This function returns all supported os of an app
     *
     * @param {string} appId the app integration id.
     *
     * @returns {Array} supported os list
     */
    getSupportedOs(appId) {

        const appDetails = this.getById(appId);
        const supportedOSTypes = Util.deepFind(appDetails, 'attributes.custom.manifest.os');

        return supportedOSTypes;

    },


    getAll() {

        return _appIntegrations;

    },

    getObservable() {

        return observableAppIntegrations;

    },

    /**
     * Return the integration details for a given integration id.
     * @param appIntegrationId The integration id(acronym)
     */
    getById(appIntegrationId) {

        return _appIntegrations
            .find(integration => (String(integration.id) === String(appIntegrationId)));

    },

    /**
     * Return the integration details for a given prototype.
     * @param prototype The integration prototype(ex: antivirus)
     */
    getByPrototype(prototype) {

        return _appIntegrations.find(integration =>
            (String(integration.attributes.prototype) === String(prototype)));

    },

    /**
     * Return the integration details for a given prototype and license type.
     * @param prototype The integration prototype(ex: antivirus)
     * @param licenseType The license type (ex: free / paid / trial)
     */
    getByPrototypeAndLicenseType(prototype, licenseType) {

        return _appIntegrations.find(integration =>
            (String(integration.attributes.prototype) === String(prototype) &&
            integration.attributes.license_type === licenseType));

    },

    /**
     * @ngdoc function
     * @name repositories.AppIntegrationsRepository#getSidebarAppByPrototype
     * @methodOf repositories.AppIntegrationsRepository
     * @function
     *
     * @description
     * This function looks the app which is displayed in the left sidebar based of its prototype
     *
     * @param {string} prototype the prototype.
     *
     * @returns {Object} the app integration object
     */
    getSidebarAppByPrototype(prototype) {

        return _appIntegrations.find(integration => (
            Util.deepFind(integration, 'attributes.prototype') === prototype &&
                Util.deepFind(integration, 'attributes.custom.manifest.appType')
        ));

    },

    /**
     * @ngdoc function
     * @name repositories.AppIntegrationsRepository#getAppByPrototype
     * @methodOf repositories.AppIntegrationsRepository
     * @function
     *
     * @description
     * This function returns the appIntegration  by prototype
     *
     * @param {string} prototype the prototype.
     *
     * @returns {Object} the app integration object
     */
    getAppByPrototype(prototype) {

        return _appIntegrations.find(integration =>

            Util.deepFind(integration, 'attributes.prototype') === prototype);

    },

    /**
     *
     * @param userId to be deleted
     * @param appId
     * @param checkOnlyPaidApps optional -if is true, return only the paid bundle components
     * @returns {{apps: Array, components: Array}}
     */
    getIncludes(userId, appId, checkOnlyPaidApps) {

        let includedApps = [];
        const includedComponents = [];
        const self = this;

        const app = _.findWhere(observableAppIntegrations.value, { id: appId });

        if (!angular.isUndefined(app)) {

            if (app.attributes.type === 'bundle') {

                includedApps = app.relationships.apps.data;
                _.each(includedApps, (item) => {

                    const componentApp = _.findWhere(
                        self.observableAppIntegrations.value,
                        { id: item.id },
                    );
                    if (!angular.isUndefined(componentApp)) {

                        if (componentApp.attributes.prototype) {

                            if (checkOnlyPaidApps) {

                                if (componentApp.attributes.license_type === 'paid') {

                                    includedComponents.push(componentApp.attributes.prototype);

                                }

                            } else {

                                includedComponents.push(componentApp.attributes.prototype);

                            }

                        }

                    }

                });

            } else if (checkOnlyPaidApps) {

                if (app.attributes.license_type === 'paid') {

                    includedComponents.push(app.attributes.prototype);

                }

            } else {

                includedComponents.push(app.attributes.prototype);

            }

        }
        return { apps: includedApps, components: includedComponents };

    },
    /**
     * Return the app integration name for a given integration id.
     * @param appIntegrationId The integration id(acronym)
     */
    getAppName(appIntegrationId) {

        const app = this.getById(appIntegrationId);
        return Util.deepFind(app, 'attributes.resource.oeName');

    },
};

export default AppIntegrationsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.appIntegrationsRepository.js